import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { connect } from 'react-redux';
import actions from 'actions';
import constants from 'constants';
import Quiz from 'containers/Quiz/Quiz';
import MobileNavbar from 'containers/Navbar/MobileNavbar';
import UsersPopup from 'containers/Dashboard/UsersPopup';
import ConfirmationModal from 'containers/Admin/ConfirmationModal';

const {
  hideModal
} = actions;

const {
  MODAL_TYPE_QUIZ,
  MODAL_TYPE_NAVBAR,
  MODAL_TYPE_DASHBOARD,
  MODAL_TYPE_DELETE_CONFIRMATION
} = constants;

class Modal extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
  }

  modalContent = () => {
    switch (this.props.modalType) {
      case MODAL_TYPE_QUIZ:
        return <Quiz { ...this.props.modalContentProps } />
      case MODAL_TYPE_NAVBAR:
        return <MobileNavbar modalHide={this.props.hideModal} />
      case MODAL_TYPE_DASHBOARD:
        return <UsersPopup modalHide={this.props.hideModal} users={this.props.modalContentProps.users}  />
      case MODAL_TYPE_DELETE_CONFIRMATION:
        return <ConfirmationModal />
      default:
        return null;
    }
  }

  isDialogShowed = () => (
    this.props.modalType != MODAL_TYPE_NAVBAR
  )

  className = () => (
    this.props.modalType == MODAL_TYPE_DASHBOARD ? 'dashboard_modal' : ''
  )

  render() {
    const {
      modalType
    } = this.props;

    if (!modalType) return null;

    console.log(this.props);
    return (
        <ModalContainer onClose={this.props.hideModal}>
          <div className={this.className()}>
            {this.isDialogShowed() ?
              <ModalDialog onClose={this.props.hideModal} style={{ width: '500px'}}>
                <div className="modal-close">
                  <a onClick={this.props.hideModal}
                   href="javascript:void(0)" className="modal_test_close modal-action modal-close">
                    <img src="/assets/img/close.png" alt="close"/>
                  </a>
                </div>
                <this.modalContent />
              </ModalDialog> :
              <this.modalContent />
            }
          </div>
        </ModalContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  modalType: state.modal.modalType,
  modalContentProps: state.modal.modalContentProps
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  hideModal: () => dispatch(hideModal())
});


export default connect(mapStateToProps, mapDispatchToProps)(Modal);



/** WEBPACK FOOTER **
 ** ./src/containers/Modal/Modal.jsx
 **/